/** La table sert aussi à construire le filtre Mongo sans charger les œuvres. */
export const REGLES_COMPLETUDE = [
    {
        champ: 'mediaPrincipalId',
        cibles: ['site', 'plateformes', 'salle'],
        bloquantes: ['plateformes'],
    },
    { champ: 'creditPhoto', cibles: ['site', 'plateformes'], bloquantes: [] },
    { champ: 'technique', cibles: ['site', 'plateformes', 'salle'], bloquantes: ['plateformes'] },
    { champ: 'dimensions', cibles: ['site', 'plateformes', 'salle'], bloquantes: ['plateformes'] },
    { champ: 'annee', cibles: ['site', 'plateformes'], bloquantes: [] },
    { champ: 'description.fr', cibles: ['site'], bloquantes: [] },
    { champ: 'description.en', cibles: ['site'], bloquantes: [] },
    {
        champ: 'prixPublicCentimes',
        cibles: ['site', 'plateformes', 'salle'],
        bloquantes: ['site', 'plateformes'],
    },
];
export function champsDeLOeuvre(cible, contexte) {
    return REGLES_COMPLETUDE.filter((regle) => {
        if (!regle.cibles.includes(cible))
            return false;
        if (regle.champ.startsWith('description.')) {
            return contexte.siteBilingue || regle.champ === `description.${contexte.languePrincipale}`;
        }
        return true;
    }).map((regle) => ({ champ: regle.champ, bloquant: regle.bloquantes.includes(cible) }));
}
export function manquesDeLOeuvre(oeuvre, cible, contexte) {
    const vide = (texte) => !texte?.trim();
    return champsDeLOeuvre(cible, contexte).filter(({ champ }) => {
        switch (champ) {
            case 'mediaPrincipalId':
                return oeuvre.mediaPrincipalId == null;
            case 'creditPhoto':
                return oeuvre.mediaPrincipalId != null && vide(contexte.creditPhotoPrincipal);
            case 'technique':
                return vide(oeuvre.technique?.fr) && vide(oeuvre.technique?.en);
            case 'dimensions': {
                const d = oeuvre.dimensions;
                return !d || !((d.hauteur > 0 && d.largeur > 0) || (d.diametre ?? 0) > 0);
            }
            case 'annee':
                return oeuvre.annee == null;
            case 'description.fr':
                return vide(oeuvre.description?.fr);
            case 'description.en':
                return vide(oeuvre.description?.en);
            case 'prixPublicCentimes':
                return oeuvre.prixVisible === true && oeuvre.prixPublicCentimes == null;
        }
    });
}
//# sourceMappingURL=completude-oeuvre.js.map